const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')
const {
  LANG_COMMON,
  LANG_GIANT,
} = require('./../../../../languageIdList')
const {
  ogreDescription,
  ogreNote,
} = require('./../../../../textCommonParts')
const {
  CREATURE_TYPE_GIANT,
  CREATURE_TYPE_OGRE,
} = require('./../../../../creatureTypeIdList')
const {ALIGNMENT_CE} = require('./../../../../aligmentList')
const {ATTACK_MELEE_WEAPON} = require('./../../../../attackTypeList')
const {CR_4} = require('./../../../../crList')
const {CREATURE_OGRE_BATTERING_RAM} = require('./../../../../creatureIdList')
const {DAMAGE_BLUDGEONING} = require('./../../../../damageTypeList')
const {GEAR_RING_MAIL} = require('./../../../../gearIdList')
const {SENSE_DARK_VISION} = require('./../../../../senseList')
const {SIZE_LARGE} = require('./../../../../sizeList')
const {SOURCE_MTOF} = require('./../../../../sourceList')
const {SPEED_WALK} = require('./../../../../speedList')

module.exports = {
  name: 'Огр таран',
  nameEn: 'Ogre Battering Ram',
  id: CREATURE_OGRE_BATTERING_RAM,
  description: [
    `Огр таран носит чудовищных размеров дубину, способную не только разносить двери в щепки, но и пробивать толпы врагов. Этих огров обучили выполнять две простые задачи: мчаться вперёд, круша вражеские строения и останавливать своей дубиной наступление противников.`,
    ...ogreDescription,
  ],
  note: ogreNote,
  sizeType: SIZE_LARGE,
  creatureTypeIdList: [
    CREATURE_TYPE_GIANT,
    CREATURE_TYPE_OGRE,
  ],
  alignmentId: ALIGNMENT_CE,
  source: {
    id: SOURCE_MTOF,
    page: 218,
  },
  armor: {
    ac: 14,
    gearId: GEAR_RING_MAIL,
  },
  hp: {
    diceCount: 7,
  },
  speed: {
    [SPEED_WALK]: 40,
  },
  params: {
    [PARAM_STR]: 19,
    [PARAM_DEX]: 8,
    [PARAM_CON]: 16,
    [PARAM_INT]: 5,
    [PARAM_WIT]: 7,
    [PARAM_CHA]: 7,
  },
  senseList: [
    {
      id: SENSE_DARK_VISION,
      value: 60,
    },
  ],
  languageList: [
    LANG_COMMON,
    LANG_GIANT,
  ],
  cr: CR_4,
  featureList: [
    {
      name: 'Осадное чудовище',
      description: `Огр наносит двойные повреждение объектам и строениям.`,
    },
  ],
  actionList: [
    {
      name: 'Удар',
      description: `Огр может оттолкнуть цель на 5 футов если она Огромного или меньшего размера.`,
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: 6,
        range: 5,
        hit: {
          type: DAMAGE_BLUDGEONING,
          diceCount: 2,
          diceType: 10,
          diceBonus: 4,
        },
      },
    },
  ],
}
